import { apiFetch } from '../api';
// src/components/FeePayment.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/FeePayment.css';

const FeePayment = () => {
  const [selectedClass, setSelectedClass] = useState('');
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState('');
  const navigate = useNavigate();

  const classOptions = ['Nursery', 'LKG', 'UKG', ...Array.from({ length: 10 }, (_, i) => `${i + 1}`)];

  useEffect(() => {
    if (selectedClass) {
      apiFetch(`get_students_by_class.php?class_name=${selectedClass}`, {
        credentials: 'include'
      })
        .then(res => res.json())
        .then(data => setStudents(data));
    } else {
      setStudents([]);
    }
  }, [selectedClass]);

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate('/fee-payment-entry', { state: { selectedStudent } });
  };

  return (
    <div className="fp-container">
      <form onSubmit={handleSubmit} className="fp-form">
        <h2 className="fp-title">💳 Fee Payment Portal</h2>

        <div className="fp-group">
          <label htmlFor="class" className="fp-label">Select Class</label>
          <select
            id="class"
            value={selectedClass}
            onChange={e => setSelectedClass(e.target.value)}
            className="fp-select"
            required
          >
            <option value="">-- Choose Class --</option>
            {classOptions.map(cls => (
              <option key={cls} value={cls}>{cls}</option>
            ))}
          </select>
        </div>

        <div className="fp-group">
          <label htmlFor="student" className="fp-label">Select Student</label>
          <select
            id="student"
            value={selectedStudent}
            onChange={e => setSelectedStudent(e.target.value)}
            className="fp-select"
            required
          >
            <option value="">-- Choose Student --</option>
            {students.map(student => (
              <option key={student.id} value={student.id}>{student.full_name}</option>
            ))}
          </select>
        </div>

        <button type="submit" className="fp-button">Proceed to Payment</button>
      </form>
    </div>
  );
};

export default FeePayment;
